import { Injectable } from "@angular/core";
import { StylesService } from "@df/core/service/styles";

@Injectable({
    providedIn: 'root'
})
export class StylesServiceDecorator extends StylesService {
    protected override setSCrollTop() {
        // kill the scroll top
    }
}